<template>
<div class="chapter">
<div class="inner_page">
<p class="epit">It’s a treat, being a long-distance runner, out in the world by yourself . . .</p>
<p class="ep-att">—Alan Sillitoe, <span class="txit">The Loneliness of the Long-Distance Runner</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi.vue?e62b4bfa